// @core/api/endpoints/localization/approve_translation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ApproveTranslationRequest,
  TranslationResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Approve translation
 * Marks a translation as approved for production use.
 */
export async function ApproveTranslation(
  translation_id: string,
  data: ApproveTranslationRequest,
  options?: RequestOptions
): Promise<TranslationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/translations/:translation_id/approve`;
  requestPath = requestPath.replace(':translation_id', encodeURIComponent(translation_id));
  const requestOptions = options;
  return client.post<TranslationResponse>(requestPath, data, requestOptions);
}
